import { useState } from 'react';
import { THEME_CATALOG, getTheme, type ThemeId } from '../../config/themes';

type Props = {
  activeTheme: ThemeId;
  onSelectTheme: (themeId: ThemeId) => void;
  placement?: 'topbar' | 'settings' | 'mobile';
};

export const ThemePicker = ({ activeTheme, onSelectTheme, placement = 'topbar' }: Props) => {
  const [open, setOpen] = useState(false);
  const selected = getTheme(activeTheme);
  const options = (
    <div className="theme-options" id={`theme-options-${placement}`} role="group" aria-label="Planner colors">
      {THEME_CATALOG.map((theme) => (
        <button
          type="button"
          className="theme-swatch"
          key={theme.id}
          aria-label={theme.label}
          aria-pressed={theme.id === activeTheme}
          onClick={() => {
            onSelectTheme(theme.id);
            setOpen(false);
          }}
          style={{ backgroundColor: theme.swatch }}
        />
      ))}
    </div>
  );

  if (placement === 'settings' || placement === 'mobile') {
    return <div className="theme-picker" data-placement={placement}>{options}</div>;
  }

  return (
    <div
      className="theme-picker"
      data-placement={placement}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') setOpen(false);
      }}
    >
      <button
        type="button"
        className="theme-trigger"
        aria-label="Choose planner color"
        aria-expanded={open}
        aria-controls={`theme-options-${placement}`}
        onClick={() => setOpen((current) => !current)}
      >
        <span style={{ backgroundColor: selected.swatch }} aria-hidden="true" />
      </button>
      {open && options}
    </div>
  );
};
